import React from 'react'
import { FacebookLogoProps } from './FacebookLogoProps'

const FacebookLogo: React.FC<FacebookLogoProps> = ({ className }) => {
  return (
    <svg
      className={className}
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 79.57"
      fill="white"
    >
      <path
        d="M80,39.56a40,40,0,1,0-45.85,40l-.28-27.95-10.16.11-.12-11.56L33.75,40l-.09-8.77c-.1-10,5.84-15.62,15-15.71a61.7,61.7,0,0,1,9,.69l.1,9.78-5,.05c-5,.05-6.49,3.14-6.46,6.3l.08,7.51,11-.11-1.65,11.6-9.32.09.28,28A40,40,0,0,0,80,39.56Z"
        transform="translate(0 0.03)"
      />
    </svg>
  )
}

export default FacebookLogo
